import dayjs from 'dayjs';
import { formatDate } from '@fund/basic-lib/dist/lib/date';
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import { numeral } from '@fund/basic-lib/dist/lib/numeral';
import tool from './tool';
/* eslint-disable */
const HIGH_END_TAG_MAP = {
  '01': { text: '纯债策略', linkInfo: { tabIndex: '02', tagIndex: '00' } },
  '02': { text: '短债策略', linkInfo: { tabIndex: '01', tagIndex: '02' } },
  '03': { text: '固收增强', linkInfo: { tabIndex: '03', tagIndex: '01' } },
  '04': { text: '多策略', linkInfo: { tabIndex: '03', tagIndex: '02' } },
  '05': { text: '股票策略', linkInfo: { tabIndex: '04', tagIndex: '01' } },
  '06': { text: '管理期货', linkInfo: { tabIndex: '05', tagIndex: '01' } },
  '07': { text: '事件驱动', linkInfo: {} },
  '08': { text: '多空策略', linkInfo: { tabIndex: '05', tagIndex: '02' } },
  11: { text: '活钱升级', linkInfo: { tabIndex: '01', tagIndex: '01' } },
};

// 头部标签
function handleHeaderTags(params) {
  const {
    riskLevel, CARD, NSMALLTYPE, promotionConfigLabel,
  } = params;
  const nSmallType = HIGH_END_TAG_MAP?.[NSMALLTYPE]?.text;
  const linkParams = HIGH_END_TAG_MAP?.[NSMALLTYPE]?.linkInfo;
  // 策略跳转
  const level = tool.getRiskLevel(riskLevel);
  let arr = [];
  if (CARD) {
    arr = CARD.split('|');
  }
  const newArray = arr.filter((item) => {
    if (item.indexOf(nSmallType) < 0) {
      return item;
    }
  });
  const getTagInfo = ({
    tag = '',
    eventName = '',
    needArrow = false,
    linkInfo = {},
    backgroundColor = 'rgba(247, 241, 233, 0.7)',
    isNSmallType = false,
  }) => ({
    tag,
    color: '#B79574',
    backgroundColor,
    backgroundColorDark: 'rgba(247, 241, 233, 0.2)',
    linkInfo,
    eventName,
    needArrow,
    isNSmallType,
  });
  const result = [level, nSmallType, promotionConfigLabel?.title, ...newArray].filter(
    (item) => !isEmpty(item),
  );
  return result.map((item) => {
    const isNSmallType = item === nSmallType && !isEmpty(linkParams);
    if (isNSmallType) {
      return getTagInfo({
        tag: item,
        needArrow: true,
        linkInfo: {
          type: 2,
          url: `fund://mp.1234567.com.cn/weex/5cc0f0e04c6a48dea2270e6dbfaa35a3/pages/strategy-list/index?pageType=strategy&tabIndex=${linkParams.tabIndex}&tagIndex=${linkParams.tagIndex}`,
        },
        isNSmallType,
        eventName: 'gdlcpzy.tbkp.cldj.click',
      });
    }
    if (item === promotionConfigLabel?.title) {
      // 开始结束时间接口过滤
      return getTagInfo({
        tag: item,
        needArrow: promotionConfigLabel?.linkUrl,
        backgroundColor: '#FFEFDF',
        linkInfo: {
          type: 2,
          url: promotionConfigLabel?.linkUrl,
        },
        eventName: 'gdlcpzy.tbkp.yycldj.click',
      });
    }
    return getTagInfo({
      tag: item,
    });
  });
}

// 浮动货币 头部信息
function formatFloatCurrencyHeaderInfo(params) {
  const { mui, jzrq, syi } = params;
  return {
    riseDesc: `万元收益${!isEmpty(jzrq) ? jzrq.substring(5, 10) : '--'}`,
    riseValue: !isEmpty(mui) ? `${Number(mui).toFixed(4)}` : '--',
    netDesc: '七日年化',
    netValue: !isEmpty(syi) ? `${Number(syi).toFixed(4)}%` : '--',
  };
}

// 固定收益 头部信息
function formatFixedProfitHeaderInfo(params) {
  const { PROFITANNUAL } = params;
  return {
    desc: '业绩报酬计提准则',
    value: !isEmpty(PROFITANNUAL) ? `${numeral(PROFITANNUAL).format('0.00')}%` : '--',
    color: tool.highEndFundColor(PROFITANNUAL),
  };
}

// 浮动收益和净值固收 头部信息
function formatFloatProfitAndNetFixedProfitHeaderInfo(params) {
  const {
    JZRQ,
    NAV,
    Y,
    SE,
    OVERCARRY,
    PROFITANNUAL,
    ANNUAL,
    STABILSHDATE,
    ACHIEVESECTION,
    ACHIEVETYPE,
  } = params;
  function handleMiddleInfo(
    PROFITANNUALParams,
    annualParam,
    overCarryParams,
  ) {
    const displayAnnual = [0, 2].includes(parseInt(ACHIEVETYPE, 10));
    if ((!isEmpty(PROFITANNUALParams) && !displayAnnual) || Number(ACHIEVETYPE) === 1) {
      return {
        isShow: true,
        desc: '业绩报酬计提基准',
        value: `${numeral(PROFITANNUALParams).format('0.00')}%`,
        color: tool.highEndFundColor(0),
        overCarry: overCarryParams,
      };
    }
    if (!isEmpty(annualParam) || displayAnnual) {
      return {
        isShow: true,
        desc: '成立来年化收益',
        value: !isEmpty(annualParam) ? `${numeral(annualParam).format('0.00')}%` : '--',
        color: tool.highEndFundColor(annualParam),
      };
    }
    return { isShow: false };
  }
  const middle = handleMiddleInfo(PROFITANNUAL, ANNUAL, OVERCARRY);
  const realDate = formatDate(new Date(STABILSHDATE?.replace(/-/g, '/')), 'yyyy-MM-dd');
  const diff = dayjs().diff(dayjs(realDate), 'year', true);
  const establishMoreThanYear = !isEmpty(STABILSHDATE) && diff && diff >= 1;
  // 展示表格
  // 当业绩计提仅1个数值，即表格不含标题的内容行数≤2行时：取产品近1年收益；若不满1年，则取历史年化收益；若没有历史年化收益，则取PROFITANNUAL
  // 当业绩计提超过1个数值，即表格含标题的内容行数＞2行时，取PROFITANNUAL
  const formLines = ACHIEVESECTION?.split(';');
  const lessThanYearValue = !isEmpty(ANNUAL) ? ANNUAL : PROFITANNUAL;
  const singleLineValue = establishMoreThanYear ? Y : lessThanYearValue;
  const displayValue = formLines?.length <= 2 ? singleLineValue : PROFITANNUAL;

  const handleSyl = (y, se) => {
    if (!isEmpty(y)) {
      return {
        desc: '近1年',
        value: `${numeral(y).format('0.00')}%`,
        color: tool.highEndFundColor(y),
      };
    }
    return {
      desc: '成立来',
      value: !isEmpty(se) ? `${numeral(se).format('0.00')}%` : '--',
      color: tool.highEndFundColor(se),
    };
  };
  return {
    sylDesc: handleSyl(Y, SE).desc,
    sylValue: handleSyl(Y, SE).value,
    middleDesc: middle?.desc || '',
    middleValue: middle?.value || '',
    middleColor: middle?.color || '#000000',
    middleOverCarry: middle?.overCarry || '',
    middleDisplayValue: !isEmpty(displayValue) ? `${numeral(displayValue).format('0.00')}%` : '--',
    netDesc: `净值(${!isEmpty(JZRQ) ? JZRQ.substring(5, 10) : '--'})`,
    netValue: !isEmpty(NAV) ? numeral(NAV).format('0.0000') : '--',
  };
}

// 新发基金 头部信息
function formatNewHighEndHeaderInfo(params) {
  const { ISSBDATE, ISSEDATE } = params;
  return {
    startTime: ISSBDATE,
    endTime: ISSEDATE,
  };
}

function formatHeaderBottomInfo(params) {
  const {
    EXPIRESPECIALTYPE, OPERATIONPERIOD, minInvest, fType,
  } = params;
  const temp = [
    {
      icon: 'https://j5.dfcfw.com/sc/image/202304/20230428015736.png',
      content: `起购金额${minInvest > 10000 ? `${minInvest / 10000}万` : `${minInvest}`}`,
    },
  ];
  if (fType === '浮动货币型' || (isEmpty(EXPIRESPECIALTYPE) && isEmpty(OPERATIONPERIOD))) {
    return temp;
  }

  return [
    {
      icon: 'https://j5.dfcfw.com/sc/image/202304/20230428015736.png',
      content: `起购金额${minInvest > 10000 ? `${minInvest / 10000}万` : `${minInvest}`}`,
    },
    {
      icon: 'https://j5.dfcfw.com/sc/image/202304/20230428015722.png',
      content: `${EXPIRESPECIALTYPE ? '锁定期' : '投资期限'}${OPERATIONPERIOD}`,
    },
  ];
}

// 新发基金提示信息
function handleHighEndTips(params) {
  const { PROFITANNUAL, OVERCARRY } = params;
  if (!isEmpty(PROFITANNUAL) || !isEmpty(OVERCARRY)) {
    const text1 = `本期业绩报酬计提基准为${
      isEmpty(PROFITANNUAL) ? '' : `${numeral(PROFITANNUAL).format('0.00')}%`
    }(不构成最低收益保证)。`;
    const text2 = !isEmpty(OVERCARRY)
      ? `如果业绩报酬计提期内年化收益率超出${numeral(PROFITANNUAL).format('0.00')}${
        isEmpty(PROFITANNUAL) ? '' : '%'
      }，超出部分的${OVERCARRY}%将计提为管理人业绩报酬。`
      : '';

    return !isEmpty(PROFITANNUAL) ? `${text1}\n${text2}` : text2 || '';
  }
  return '';
}

function handleHighEndLightPointInfo(params) {
  const { remark, url, fundCode } = params;
  return {
    text: isEmpty(remark) ? '' : remark.split(''),
    url: isEmpty(url) ? '' : url,
    fundCode,
  };
}

function handleStageRiseListInfo(params) {
  const { date, se, w, m, q, hy, y, twy, threeY, fy, sy, hisRank } = params || {};
  const handleItem = function (dateValue, value, stageKey = "") {
    const allInfo = hisRank?.find((item) => parseInt(item.BUYSTATE, 10) === 0) || {};
    const canBuyInfo = hisRank?.find((item) => parseInt(item.BUYSTATE, 10) === 1) || {};
    console.log("allInfo", allInfo);
    console.log("stageKey", `${stageKey}RANK`);
    console.log("allInfo", allInfo[`${stageKey}RANK`]);
    return {
      stageKey,
      date: dateValue,
      rise: numeral(value).format("0.00"),
      rank: isEmpty(allInfo[`${stageKey}RANK`]) ? "--" : allInfo[`${stageKey}RANK`],
      rankTotal: isEmpty(allInfo[`${stageKey}SC`]) ? "--" : allInfo[`${stageKey}SC`],
      rankCanBuy: isEmpty(canBuyInfo[`${stageKey}RANK`]) ? "--" : canBuyInfo[`${stageKey}RANK`],
      rankCanBuyTotal: isEmpty(canBuyInfo[`${stageKey}SC`]) ? "--" : canBuyInfo[`${stageKey}SC`],
    };
  };
  const dataList = [
    handleItem("近1周", w, "W"),
    handleItem("近1月", m, "M"),
    handleItem("近3月", q, "Q"),
    handleItem("近6月", hy, "HY"),
    handleItem("近1年", y, "Y"),
    handleItem("近2年", twy, "TWY"),
    handleItem("近3年", threeY, "TRY"),
    handleItem("近5年", fy, "FY"),
    handleItem("今年来", sy, "SY"),
    handleItem("成立以来", se, "SE"),
  ];

  const jzrq = Date.parse(date);
  const now = Date.parse(new Date().toString());
  const days = (now - jzrq) / 1000 / 60 / 60 / 24;
  // 超过90天
  const lastUpdateTime = days > 90 ? date : "";
  return {
    lastUpdateTime,
    dataList,
  };
}

function handleTradeMustKnowProgressInfo(params) {
  console.log('handleTradeMustKnowProgressInfo', params);
  if (!params) {
    return [];
  }
  const {
    FUNDBUSINTYPE,
    CLOSEDAYS,
    SELLSTATE,
    IPOBEGINDATE,
    IPOENDDATE,
    STABILSHDATE,
    MARKETBEGINDATE,
  } = params;
  let { NEXTBEGINDATE, MARKETENDDATE } = params;
  if (tool.judgeTimeIsExpired(MARKETBEGINDATE)) {
    MARKETENDDATE = null;
    NEXTBEGINDATE = MARKETBEGINDATE;
  }
  if ([2, 3].includes(parseInt(SELLSTATE, 10))) {
    return [];
  }
  if (FUNDBUSINTYPE === '1') {
    // 认购
    if (CLOSEDAYS === 0) {
      // 每日开放申购
      return [
        {
          firstTitle: '募集开始',
          firstSubTitle: !isEmpty(IPOBEGINDATE)
            ? formatDate(new Date(IPOBEGINDATE.replace(/-/g, '/')), 'yyyy-MM-dd')
            : '',
          text: '募集中',
          style: { backgroundImage: 'linear-gradient(to top left, #EAAF69, #BA8649)' },
          flex: 5,
          textStyle: { marginLeft: '16px', color: '#FFFFFF' },
        },
        {
          firstTitle: '募集结束',
          firstSubTitle: !isEmpty(IPOENDDATE)
            ? formatDate(new Date(IPOENDDATE.replace(/-/g, '/')), 'yyyy-MM-dd')
            : '',
          text: '',
          style: { backgroundColor: '#F4E1CA' },
          flex: 4,
          textStyle: { marginLeft: '16px', color: '#BB874A' },
        },
        {
          firstTitle: '产品成立',
          firstSubTitle: STABILSHDATE || '待定',
          lastTitle: '预计下一开放日',
          lastSubTitle: !isEmpty(NEXTBEGINDATE)
            ? formatDate(new Date(NEXTBEGINDATE.replace(/-/g, '/')), 'yyyy-MM-dd')
            : '以机构公告为准',
          text: '进入封闭期',
          style: { backgroundColor: '#F6EDDD' },
          flex: 7,
          textStyle: { marginRight: '16', color: '#BB874A', textAlign: 'right' },
        },
      ];
    }
    // 存在封闭期
    return [
      {
        firstTitle: '募集开始',
        firstSubTitle: !isEmpty(IPOBEGINDATE)
          ? formatDate(new Date(IPOBEGINDATE.replace(/-/g, '/')), 'yyyy-MM-dd')
          : '',
        text: '募集中',
        style: { backgroundImage: 'linear-gradient(to top left, #EAAF69, #BA8649)' },
        flex: 5,
        textStyle: { marginLeft: '16px', color: '#FFFFFF' },
      },
      {
        firstTitle: '募集结束',
        firstSubTitle: !isEmpty(IPOENDDATE)
          ? formatDate(new Date(IPOENDDATE.replace(/-/g, '/')), 'yyyy-MM-dd')
          : '',
        text: '',
        style: { backgroundColor: '#F4E1CA' },
        flex: 4,
        textStyle: { marginLeft: '16px', color: '#BB874A' },
      },
      {
        firstTitle: '产品成立',
        firstSubTitle: !isEmpty(STABILSHDATE)
          ? formatDate(new Date(STABILSHDATE?.replace(/-/g, '/')), 'yyyy-MM-dd')
          : '待定',
        lastTitle: '预计下一开放日',
        lastSubTitle: !isEmpty(NEXTBEGINDATE)
          ? formatDate(new Date(NEXTBEGINDATE?.replace(/-/g, '/')), 'yyyy-MM-dd')
          : '以机构公告为准',
        text: isEmpty(CLOSEDAYS) ? '进入封闭期' : `封闭期${CLOSEDAYS}天`,
        style: { backgroundColor: '#F6EDDD' },
        flex: 7,
        textStyle: { marginRight: '16', color: '#BB874A', textAlign: 'right' },
      },
    ];
  }
  if (FUNDBUSINTYPE === '0') {
    // 申购
    if (parseInt(SELLSTATE, 10) === 0) {
      // 购买状态
      if (CLOSEDAYS > '0') {
        // 存在封闭期
        return [
          {
            firstTitle: '开放申购',
            firstSubTitle: !isEmpty(MARKETBEGINDATE)
              ? formatDate(new Date(MARKETBEGINDATE.replace(/-/g, '/')), 'yyyy-MM-dd')
              : '',
            text: '开放申购中',
            style: { backgroundImage: 'linear-gradient(to top left, #EAAF69, #BA8649)' },
            flex: 5,
            textStyle: { marginLeft: '16px', color: '#FFFFFF' },
          },
          {
            firstTitle: '进入封闭期',
            firstSubTitle: !isEmpty(MARKETENDDATE)
              ? formatDate(new Date(MARKETENDDATE.replace(/-/g, '/')), 'yyyy-MM-dd')
              : '',
            lastTitle: '预计下一开放日',
            lastSubTitle: !isEmpty(NEXTBEGINDATE)
              ? formatDate(new Date(NEXTBEGINDATE.replace(/-/g, '/')), 'yyyy-MM-dd')
              : '以机构公告为准',
            text: isEmpty(CLOSEDAYS) ? '进入封闭期' : `封闭期${CLOSEDAYS}天`,
            style: { backgroundColor: '#F6EDDD' },
            flex: 7,
            textStyle: { marginRight: '16', color: '#BB874A', textAlign: 'right' },
          },
        ];
      }
      // 每日开放申购
      return [
        {
          firstTitle: '产品成立',
          firstSubTitle: !isEmpty(STABILSHDATE)
            ? formatDate(new Date(STABILSHDATE?.replace(/-/g, '/')), 'yyyy-MM-dd')
            : '待定',
          text: '每日开放申购',
          style: { backgroundImage: 'linear-gradient(to top left, #EAAF69, #BA8649)' },
          flex: 5,
          textStyle: { marginLeft: '16px', color: '#FFFFFF' },
        },
      ];
    }
    // 开售 预约 售罄
    return [
      {
        firstTitle: '进入封闭期',
        firstSubTitle: !isEmpty(MARKETENDDATE)
          ? formatDate(new Date(MARKETENDDATE.replace(/-/g, '/')), 'yyyy-MM-dd')
          : '',
        lastTitle: '预计下一开放日',
        lastSubTitle: !isEmpty(NEXTBEGINDATE)
          ? formatDate(new Date(NEXTBEGINDATE.replace(/-/g, '/')), 'yyyy-MM-dd')
          : '以机构公告为准',
        text: '等待开放日申购',
        style: { backgroundImage: 'linear-gradient(to top left, #EAAF69, #BA8649)' },
        flex: 5,
        textStyle: { marginLeft: '16px', color: '#FFFFFF' },
      },
    ];
  }
  return [];
}

function handleTradeRuleInfo(params) {
  const {
    FUNDBUSINTYPE,
    MARKETBEGINDATE,
    MARKETENDDATE,
    OPENRULE,
    OPERATIONPERIOD,
    MININVEST,
    MINAPPEND,
    SGRATEMARK,
    RATE,
    REDEEMBEGINDATE,
    REDEEMENDDATE,
    SHRATEMARK,
    EXPIRESPECIALTYPE,
    REMARK,
    PERFORMANCEFEE: performanceRule,
  } = params;
  const buyRule = [
    {
      name: `最近${FUNDBUSINTYPE === '0' ? '申购' : '认购'}开放期`,
      content:
        MARKETBEGINDATE === MARKETENDDATE ? MARKETENDDATE : `${MARKETBEGINDATE} ~ ${MARKETENDDATE}`,
    },
    {
      name: '开放规则',
      content: OPENRULE,
    },
    {
      name: EXPIRESPECIALTYPE ? '锁定期' : '投资期限',
      content: OPERATIONPERIOD,
    },
    {
      name: '起购金额',
      content: `${
        MININVEST > 10000 ? `${MININVEST / 10000}万` : `${MININVEST}`
      }, ${tool.getUnit(MINAPPEND)}元整数倍增加`,
    },
    {
      name: `${FUNDBUSINTYPE === '0' ? '申购' : '认购'}费率`,
      content: SGRATEMARK ? SGRATEMARK.replace(/_/g, ';\n') : RATE || '0.00%',
    },
    {
      name: '业绩报酬计提规则',
      content: performanceRule,
    },
    {
      name: '其他',
      content: REMARK,
    },
  ].filter((item) => {
    if (item.content) {
      return item;
    }
  });
  const sellRule = [
    {
      name: '最近赎回开放期',
      content:
        REDEEMBEGINDATE === REDEEMENDDATE
          ? REDEEMBEGINDATE
          : `${REDEEMBEGINDATE} ~ ${REDEEMENDDATE}`,
    },
    {
      name: '赎回费率',
      content: SHRATEMARK,
    },
  ].filter((item) => {
    if (item.content) {
      return item;
    }
  });
  return { buyRule, sellRule, performanceRule };
}

function handleHighEndArchivesInfo(params) {
  const {
    fundCode,
    fundName,
    STABILSHDATE,
    WHOLELIMIT,
    MNGSCALE,
    REGCAPITAL,
    FOUNDDATE,
    // FUNDMANAGER,
    // INVESTMENTMANAGERINTRO,
    MANAGER,
    MANAGEMENTINTRO,
    managerInfoList,
    managerCode,
  } = params;
  const curManager = (managerInfoList || [])
    .map((info) => ({
      degree: info?.DEGREE ?? '--', // 学历
      name: info?.MGRNAME ?? '--', // 姓名
      workYears: info?.PATICTERM ?? '--', // 从业年限
      serviceDays: tool.formatDays(info?.HOLDDAYS ?? '--'), // 任职时间
      resume: info?.RESUME ?? '--', // 简历
      yieldSince: info?.YIELDSINCES ?? '--', // 收益
      mgrId: info?.MGRID ?? '',
      tags: [],
    }))
    .filter((item) => !isEmpty(item.name));
  const managerInfo = [
    {
      desc: '现任经理',
      managers: curManager,
      // content: INVESTMENTMANAGERINTRO,
      textLines: 0,
      showBtn: false,
    },
    {
      desc: '管理人',
      managers: [
        {
          name: MANAGER,
          managerCode,
          tags: [
            !isEmpty(MNGSCALE) ? `资产规模${MNGSCALE}` : null,
            !isEmpty(REGCAPITAL) ? `注册资本${REGCAPITAL.toFixed(2)}万元` : null,
            !isEmpty(FOUNDDATE)
              ? `${formatDate(new Date(FOUNDDATE.replace(/-/g, '/')), 'yyyy-MM-dd')}年成立`
              : null,
          ].filter((item) => {
            if (item) {
              return item;
            }
          }),
        },
      ],
      content: MANAGEMENTINTRO,
      textLines: 0,
      showBtn: false,
    },
  ].filter((item) => {
    if (item.managers) {
      return item;
    }
  });
  return {
    managerInfo,
    fundCode,
    fundName,
    setUpDate: !isEmpty(STABILSHDATE)
      ? formatDate(new Date(STABILSHDATE?.replace(/-/g, '/')), 'yyyy-MM-dd')
      : '',
    WHOLELIMIT: tool.getUnit(WHOLELIMIT),
  };
}

function handleRiskData({ rankInfo, ...rest }) {
  // 近1年、近3年、近5年
  const data = [];
  (rankInfo || [])
    .sort((a, b) => Number(a.BUYSTATE) - Number(b.BUYSTATE))
    .forEach((item) => {
      const temp = [];
      ['Y', 'TRY', 'FY'].forEach((key) => {
        const getIndexValue = (targetKey, periodKey) => ({
          value: rest[`${targetKey}${periodKey}`],
          rank: item[`${targetKey}_RANK_${periodKey}`],
          total: item[`${targetKey}_NUM_${periodKey}`],
        });
        temp.push({
          maxRetra: getIndexValue('MAXRETRA', key),
          sharp: getIndexValue('SHARP', key),
          fixDay: getIndexValue('NVRENO', key),
          riskProfit: getIndexValue('CALMAR', key),
        });
      });
      data.push(...(temp || []));
    });
  const levelConfig = ["不佳", "一般", "良好", "优秀"]
  const descMap = {
    maxRetra: { name: "控回撤能力", label: '最大回撤' },
    fixDay: { name: "修复能力", label: '净值修复天数' },
    riskProfit: { name: "风险收益能力", label: '收益回撤比' },
    sharp: { name: "投资性价比", label: '夏普比率' },
  }
  return (data || []).map((item) => {
    const temp = [];
    Object.keys(item).forEach((key) => {
      let percent = 1 - parseFloat(item[key].rank) / parseFloat(item[key].total);
      if (percent * 100 < 0.5) {
        percent = 0.01;
      }
      if (percent * 100 > 99.5) {
        percent = 0.99;
      }
      let realValue = isEmpty(item[key].value) ? '--' : item[key].value;
      if (!isEmpty(realValue)) {
        if (key === 'maxRetra') {
          realValue = `${numeral(Math.abs(realValue)).format('0.00')}%`;
        } else if (['riskProfit', 'sharp'].includes(key)) {
          realValue = `${numeral(realValue).format('0.00')}`;
        } else {
          realValue = `${realValue}天`;
        }
      }
      temp.push({
        key,
        name: descMap[key]?.name ?? '',
        label: descMap[key]?.label ?? '',
        value: realValue,
        percent: isEmpty(percent) ? '' : percent,
        levelText: levelConfig[Math.floor(percent * 4)],
        compare: isEmpty(percent) ? '暂无排名' : `${Number(percent * 100).toFixed(0)}%`,
      });
    });
    return temp;
  });
}

function handleAchievementData(params) {
  const {
    maxRetraHY,
    maxRetraY,
    maxRetraTWY,
    maxRetraTRY,
    maxRetraFY,
    maxRetraSY,
    maxRetraSE,
    sharpSY,
    sharpSE,
    sharpHY,
    sharpY,
    sharpTWY,
    sharpTRY,
    sharpFY,
    halfYearFixDay,
    oneYearFixDay,
    twoYearFixDay,
    threeYearFixDay,
    fiveYearFixDay,
    currentYearFixDay,
    establishedFixDay,
  } = params;
  const handleData = function (date, maxReturn, sharp, netFixDay) {
    console.log('netFixDay>>>', netFixDay);
    return {
      date,
      maxReturn: !isEmpty(maxReturn) ? `${numeral(Math.abs(maxReturn)).format('0.00')}%` : '--',
      sharp: !isEmpty(sharp) ? `${numeral(sharp).format('0.00')}` : '--',
      netFixDay: isEmpty(netFixDay) ? '--' : `${netFixDay}天`,
    };
  };
  return [
    handleData('近6月', maxRetraHY, sharpHY, halfYearFixDay),
    handleData('近1年', maxRetraY, sharpY, oneYearFixDay),
    handleData('近2年', maxRetraTWY, sharpTWY, twoYearFixDay),
    handleData('近3年', maxRetraTRY, sharpTRY, threeYearFixDay),
    handleData('近5年', maxRetraFY, sharpFY, fiveYearFixDay),
    handleData('今年来', maxRetraSY, sharpSY, currentYearFixDay),
    handleData('成立来', maxRetraSE, sharpSE, establishedFixDay),
  ];
}

export {
  formatFloatCurrencyHeaderInfo,
  formatFixedProfitHeaderInfo,
  formatFloatProfitAndNetFixedProfitHeaderInfo,
  formatNewHighEndHeaderInfo,
  handleHighEndTips,
  handleHighEndLightPointInfo,
  handleHeaderTags,
  handleStageRiseListInfo,
  handleTradeMustKnowProgressInfo,
  handleTradeRuleInfo,
  handleHighEndArchivesInfo,
  formatHeaderBottomInfo,
  handleAchievementData,
  handleRiskData,
};
